exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".privacy{font-family:SiemensSansGlobalCC-Roman,Helvetica Neue,Helvetica,sans-serif}.privacy h1{margin:0 auto;text-align:center;font-size:24px}.privacy h2,.privacy h3{margin:48px 0 20px;color:#3c464b;font-size:24px}.privacy ul{margin-left:15px}.privacy ul>li{list-style:disc}.privacy p{margin:15px 0}.privacy li{margin:0 0 0 15px}.privacy__body{padding:0 10px 30px 10px;font-size:16px}.privacy__body h1{display:none}", ""]);

// exports
